"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = require('boolean'),
    parseBoolean = _require["boolean"];

var moment = require('moment');

var Alert = function Alert() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, Alert);

  this.id = params.id;
  this.user_id = params.user_id;
  this.text = params.text;
  this.variant = params.variant || 'info';
  this.timestamp = params.timestamp ? moment(params.timestamp).toISOString() : moment().toISOString();
  this.unread = params.unread == null ? true : parseBoolean(params.unread);
  this.archived = params.archived == null ? false : parseBoolean(params.archived);
  this.meta = params.meta || {};
};

module.exports = Alert;